import { PeriodoVacaciones, CreatePeriodoPayload, UpdatePeriodoPayload, ResultadoImportacion } from '../tipos/vacaciones';
import { API_ENDPOINTS } from '../config/apiConfig';
import { fetchJson, postJson, putJson, deleteRequest, getStoredToken } from './api';

/**
 * Obtiene todos los periodos, con filtros opcionales por anio y empleadoId.
 */
export function getAll(anio?: number, empleadoId?: number): Promise<PeriodoVacaciones[]> {
  const params = new URLSearchParams();

  if (anio !== undefined) {
    params.append('anio', anio.toString());
  }
  if (empleadoId !== undefined) {
    params.append('empleadoId', empleadoId.toString());
  }

  const queryString = params.toString();
  const url = queryString
    ? `${API_ENDPOINTS.periodos}?${queryString}`
    : API_ENDPOINTS.periodos;

  return fetchJson<PeriodoVacaciones[]>(url);
}

/**
 * Obtiene todos los periodos de un empleado especifico.
 */
export function getByEmpleado(empleadoId: number): Promise<PeriodoVacaciones[]> {
  return fetchJson<PeriodoVacaciones[]>(
    `${API_ENDPOINTS.periodos}/empleado/${empleadoId}`
  );
}

/**
 * Crea un nuevo periodo de vacaciones.
 */
export function create(payload: CreatePeriodoPayload): Promise<PeriodoVacaciones> {
  return postJson<PeriodoVacaciones>(API_ENDPOINTS.periodos, payload);
}

/**
 * Actualiza un periodo de vacaciones existente.
 */
export function update(id: number, payload: UpdatePeriodoPayload): Promise<PeriodoVacaciones> {
  return putJson<PeriodoVacaciones>(`${API_ENDPOINTS.periodos}/${id}`, payload);
}

/**
 * Elimina un periodo de vacaciones.
 */
export function remove(id: number): Promise<void> {
  return deleteRequest(`${API_ENDPOINTS.periodos}/${id}`);
}

/**
 * Importa periodos de vacaciones desde un archivo TXT usando multipart/form-data.
 */
export async function importarTxt(archivo: File): Promise<ResultadoImportacion> {
  const formData = new FormData();
  formData.append('archivo', archivo);
  const token = getStoredToken();
  const response = await fetch(API_ENDPOINTS.importarPeriodos, {
    method: 'POST',
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    body: formData,
  });
  if (response.status === 401) {
    window.location.href = '/login';
    throw new Error('Sesión expirada');
  }
  if (!response.ok) {
    const err = await response.json().catch(() => ({ message: 'Error desconocido' }));
    throw new Error(err.message || `Error HTTP ${response.status}`);
  }
  return response.json();
}
